module.exports = __webpack_public_path__ + "img/noises-16.95469ac9.jpg";